<template>
  <div>
    <div v-if="showArea === 'list'" class="list-area">
      <el-row>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleOperate('create')"
          >添加</el-button
        >
      </el-row>
      <el-row :gutter="6">
        <el-col :span="4">
          <el-select
            style="width: 100%"
            clearable
            filterable
            size="small"
            v-model="searchData.apkType"
            placeholder="应用类型"
          >
            <el-option
              v-for="item in appTypeListGp"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            clearable
            v-model="searchData.developerId"
            filterable
            placeholder="请选择开发者名称"
          >
            <el-option
              v-for="item in CompanyNameList"
              :key="item.id"
              :label="`${item.developerName}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            size="small"
            placeholder="请输入搜索备注"
            v-model="searchData.remark"
            class="input-with-select"
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="6">
        <el-col :span="8">
          <el-input
            size="small"
            placeholder="请输入搜索内容"
            v-model="searchData.keyword"
            class="input-with-select"
          >
            <el-select
              size="small"
              slot="prepend"
              v-model="searchData.chooseType"
              placeholder="请选择类型"
            >
              <el-option label="应用名称" value="appName"> </el-option>
              <el-option label="包名" value="packageName"> </el-option>
            </el-select>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-row type="flex" align="middle">
            <span style="white-space: nowrap"> 修改日期：</span>
            <el-date-picker
              size="small"
              type="daterange"
              range-separator="至"
              v-model="searchData.date"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>

            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              class="ml10"
              @click="handleSearch()"
              >查询</el-button
            >
            <ExportTable class="ml10" @download="getDownloadList"></ExportTable>
          </el-row>
        </el-col>
      </el-row>
      <PageTable
        :columns="columns"
        :tableData="tableData"
        @page-change="handleChangePage"
        @selection-change="handleSelectionChange"
      >
        <template slot-scope="{ row }" slot="createTime">
          {{ getFormattedDate(row.createTime) }}
        </template>
        <template slot-scope="{ row }" slot="modifyTime">
          {{ getFormattedDate(row.modifyTime) }}
        </template>
        <template slot-scope="{ row }" slot="apkType">{{
          row.apkType | typeDesc(appTypeListGp)
        }}</template>

        <template slot-scope="{ row }" slot="developerId">
          {{ getDeveloperName(row) }}
        </template>
        <template slot-scope="{ row }" slot="status">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeAppStatus(row)"
          >
          </el-switch>
        </template>
        <el-table-column
          label="操作"
          width="180px"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleOperate('edit', row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </PageTable>
    </div>
    <el-dialog
      top="10vh"
      destroy-on-close
      :close-on-click-modal="false"
      :title="operationType | operationTypeDesc"
      :visible.sync="dialogVisible"
      @closed="handleResetCreate()"
    >
      <Create
        ref="createRef"
        v-if="operationType === 'create' || operationType === 'edit'"
        :CompanyNameList="CompanyNameList"
        :detailData="detailData"
        @submit="handleCreateApp"
        @cancle="handleCancel('list')"
      />
    </el-dialog>
  </div>
</template>
<script>
import PageTable from "@/components/PageTable.vue";
import ExportTable from "@/components/ExportTable.vue";
import {
  appTypeListGp,
  releaseTypeList,
  appStatusList,
  appSubTypeList,
  sourceList,
  appReviewStatusList,
  MAXSIZE,
  MAXSIZEDOWN,
} from "@/common/constant/constant.js";
import { getFormattedDate } from "@/common/utils/utils.js";
import Create from "./Create.vue";
import {
  getDeveloperUserList,
  getApkList,
  editAppInfo,
  createAppInfo,
  changeStatus,
  getLanguageList,
  appBack, // 版本回退
  saveTestInfo, // 内测
  submitTestInfo, // 内测
  appReservedSave, // 预约
  appReservedSubmit, // 预约
  submitReleaseInfo, // 普通
  saveUpdateReleaseInfo, // 普通
  queryGeneral, // 普通
  getReservedById, // 预约
  queryTest, // 内测
} from "./indexServe";
import { getBusinessManagerList } from "@/common/js/api.js";
import moment from "moment";
export default {
  name: "apkManagementGp",
  components: { PageTable, Create, ExportTable },
  data() {
    let end = moment(new Date()).format("YYYY-MM-DD");
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    start = moment(start).format("YYYY-MM-DD");
    return {
      getFormattedDate,
      appTypeListGp,
      releaseTypeList,
      appStatusList,
      appSubTypeList,
      sourceList,
      appReviewStatusList,
      searchData: {
        date: [start, end],
        developerId: "",
      },
      tableData: {
        list: [],
      },
      columns: [
        {
          key: "id",
          label: "APPID",
        },
        {
          key: "appName",
          label: "应用名称",
        },
        {
          key: "packageName",
          label: "应用包名",
        },
        {
          slot: "apkType",
          label: "应用类型",
        },
        {
          slot: "developerId",
          label: "开发者",
        },
        {
          key: "remark",
          label: "备注",
        },
        {
          slot: "createTime",
          label: "创建时间",
        },
        {
          slot: "modifyTime",
          label: "修改时间",
        },
        {
          slot: "status",
          label: "是否开启推广",
        },
      ],
      visible: false, //控制drawer的显示和隐藏
      dialogVisible: false, // 控制dialog的显示和隐藏
      operationType: "", // 记录当前操作模式新建-create、编辑-edit
      showArea: "list", // 记录当前显示的区域，列表-list，应用详情-detail
      batchOperation: "", // 批量操作
      selectionIdList: [], //所有已选的id列表
      detailData: {},
      languageList: [],
      businessNameList: [],
      CompanyNameList: [],
    };
  },
  activated() {
    try {
      if (this.$route.query.creatorId) {
        this.searchData.developerId = parseInt(this.$route.query.creatorId);
        this.searchData.date = [];
      }
      this.init();
      this.getDeveloperList();
      this.getBusManaList();
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    async changeAppStatus(row) {
      // 调用接口
      editAppInfo(row)
        .then(() => {})
        .catch(() => {
          // 失败则恢复原状态
          row.status = row.status == 0 ? 1 : 0;
        });
    },
    getDeveloperName(row) {
      const finded = this.CompanyNameList.find(
        (item) => item.id == row.developerId
      );
      if (finded) return finded.developerName;
      return "";
    },
    async getDeveloperList() {
      const data = {
        page: 1,
        size: 9999,
      };
      const res = await getDeveloperUserList(data);
      if (res) {
        this.CompanyNameList = res.data.list;
      }
    },
    getOperatorAppText(row) {
      if (row.sourceType === 0) {
        return "-";
      } else {
        return row.operatorApp === 0 ? "否" : "是";
      }
    },
    // 后端请求
    // 获取商务人员列表
    async getBusManaList() {
      const res = await getBusinessManagerList({
        page: 1,
        size: MAXSIZE,
      });
      if (res && res.code === 0) {
        this.businessNameList = res.data.list;
      }
    },
    // 事件监听
    handleChangePage({ page, size }) {
      this.getTableList({ page, size });
    },
    async handleOperate(operationType, row) {
      this.operationType = operationType;
      if (["create", "edit"].includes(operationType)) {
        this.dialogVisible = true;
        this.detailData = { ...row };
      }
      // else if (["edit", "view"].includes(operationType)) {
      //   this.showArea = "detail";
      //   this.dialogVisible = false;
      //   const detailData = await this.getDetail(
      //     { releaseId: row.releaseId, sourceType: row.sourceType },
      //     row.releaseType
      //   );
      //   this.detailData = {
      //     releaseStatus: row.releaseStatus, // 应用状态
      //     releaseType: row.releaseType,
      //     appReleaseId: row.releaseId,
      //     sourceType: row.sourceType, //来源类型(0开发者平台 1运营平台)
      //     appId: row.appId,
      //     id: row.id,
      //     ...detailData,
      //   };
      // }
    },
    hanldeAppVersionBack(row) {
      this.dialogVisible = false;
      if ([1002, 1003].includes(row.releaseStatus)) {
        // 已上架&待上架的应用更改应用状态
        this.handleChangeStatus(row);
      } else {
        this.appBack({ releaseId: row.releaseId });
      }
    },
    handleCreateApp(formData) {
      formData.developerId = parseInt(formData.developerId);
      const apiName = formData.id ? editAppInfo : createAppInfo;
      apiName(formData).then((res) => {
        if (res && res.code === 0) {
          this.handleResetCreate();
          this.getTableList(); // 成功后刷新列表
        }
      });
    },
    handleChangeStatus(row) {
      this.changeStatus({
        releaseStatus: row.releaseStatus === 1003 ? 1 : 0, //发布状态(0:上架1:下架)
        releaseId: row.releaseId,
      });
    },
    handleSearch() {
      this.getTableList({ page: 1 });
    },
    handleSave(formData, releaseType) {
      // 上架类型：1--普通，2--预约，3--内测，4--首发
      let fcn = saveUpdateReleaseInfo;
      if (releaseType === 2) {
        fcn = appReservedSave;
      } else if (releaseType === 3) {
        fcn = saveTestInfo;
      }
      fcn(formData).then((res) => {
        if (res && res.code === 0) {
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 成功后刷新列表
          this.operationType = "edit";
          this.$message.success("保存成功");
        }
      });
    },
    handleSubmit(formData, releaseType) {
      // 上架类型：1--普通，2--预约，3--内测，4--首发
      let fcn = submitReleaseInfo;
      if (releaseType === 2) {
        fcn = appReservedSubmit;
      } else if (releaseType === 3) {
        fcn = submitTestInfo;
      }
      fcn(formData).then((res) => {
        if (res && res.code === 0) {
          this.showArea = "list";
          this.dialogVisible = false;
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 成功后刷新列表
          this.$message.success("提交成功");
        }
      });
    },
    handleCancel(showArea) {
      this.showArea = showArea;
      this.detailData = {};
      this.dialogVisible = false;
      this.operationType = "";
    },
    handleResetCreate() {
      this.$refs.createRef && this.$refs.createRef.resetFields();
      this.handleCancel("list");
    },
    handleSelectionChange(selection) {
      this.selectionIdList = selection.map((i) => i.releaseId);
    },
    handleBatchOperation() {
      if (this.selectionIdList.length == 0 || this.batchOperation === "") {
        const msg =
          this.batchOperation === ""
            ? "请选择操作类型"
            : "请勾选需要操作的数据";
        this.$message.error(msg);
        return;
      }
      this.changeStatus({
        releaseStatus: this.batchOperation,
        releaseId: this.selectionIdList.join(","),
      });
    },
    // 后端请求
    async getDownloadList(callback) {
      const res = await this.getTableList({ page: 1, size: MAXSIZEDOWN }, true);
      if (res) {
        const headerDisplay = {};
        this.columns.forEach((item) => {
          const key = item.key || item.slot;
          if (key !== "action") {
            headerDisplay[key] = item.label;
          }
        });
        // 处理导出的数据
        const list = res.list.map((i) => ({
          ...i,
          appCategoryId: this.$options.filters["typeDesc"](
            i.appCategoryId,
            this.appTypeListGp
          ),
          sourceType: this.$options.filters["typeDesc"](
            i.sourceType,
            this.sourceList
          ),
          releaseStatus: this.$options.filters["typeDesc"](
            i.releaseStatus,
            this.appStatusList
          ),
          releaseType: this.$options.filters["typeDesc"](
            i.releaseType,
            this.releaseTypeList
          ),
          reviewStatus: this.$options.filters["typeDesc"](
            i.reviewStatus,
            this.appReviewStatusList
          ),
        }));
        callback({
          fileName: "应用列表GP",
          headerDisplay,
          list,
        });
      }
    },
    // 获取列表
    async getTableList(params, isDownload) {
      const data = {
        page: 1,
        size: 10,
        ...this.searchData,
        ...params,
      };
      if (data.developerId == "") delete data.developerId;
      if (data.apkType == "") delete data.apkType;

      if (data.date && data.date.length !== 0) {
        data.startTime = data.date[0];
        data.endTime = data.date[1];
      }
      if (data.keyword && data.chooseType) {
        const keyword = data.keyword.trim();
        if (keyword) {
          data[data.chooseType] = keyword;
        }
      }
      const res = await getApkList(data);
      if (res) {
        // 下载时，不需要更新到table
        if (!isDownload) {
          this.tableData = res.data;
        }
        return res.data;
      }
    },
    async getDetail(params, releaseType = 1) {
      // 上架类型：1--普通，2--预约，3--内测，4--首发
      let fcn = queryGeneral;
      if (releaseType === 2) {
        fcn = getReservedById;
      } else if (releaseType === 3) {
        fcn = queryTest;
      }
      let detailData = {};
      const res = await fcn(params);
      if (res && res.code === 0) {
        detailData = res.data;
      }
      return detailData;
    },
    // 获取语言列表
    async getLanguageList() {
      const res = await getLanguageList();
      this.languageList = res.data;
    },
    async appBack(params) {
      const res = await appBack(params);
      if (res && res.code === 0) {
        this.$message.success("版本回退成功");
        this.getTableList({
          page: this.tableData.page,
          size: this.tableData.size,
        }); // 成功后刷新列表
      }
    },
    async changeStatus(params) {
      const res = await changeStatus(params);
      if (res && res.code === 0) {
        this.getTableList({
          page: this.tableData.page,
          size: this.tableData.size,
        }); // 成功后刷新列表
        this.$message.success(res.msg);
      }
    },
    // 其他
    init() {
      this.getTableList();
    },
  },
};
</script>
<style scoped lang="scss">
.input-with-select {
  /deep/.el-input-group__prepend {
    background: #fff;
    width: 80px;
  }
}
.list-area {
  position: relative;
  .page-foot {
    display: inline-block;
    position: absolute;
    margin-top: -30px;
    div {
      margin-right: 5px;
    }
  }
}
</style>
